import React, { useEffect, useState } from 'react';
import { PlayIcon } from 'lucide-react';
// import StreamVideo from "../../camera/stream-video";
// import WebRTCComponent from "../../webRTCComponent";
// import WebRTCAntMedia from "../../webRTCComponent/webRTC";
import DialogIframe from "../../dialog-iframe";
import stationCameraSvc from '../../../services/api/stationCamera';
import ThumbnailGenerator from "../../thumbnailGenerator";
// --- utils
import { convertToThumbnailUrl } from '../../../utils/helper';
import { useIntervalRerender } from '../../../hooks/useIntervalRerender';

// --- modal ---
import { StationCameraItem } from '../../../models/types/stationCamera';

const CameraComponent = ({ stationId }: { stationId: number }) => {
    const [open, setOpen] = useState(false);
    const [selectedCamera, setSelectedCamera] = useState<StationCameraItem | null>(null);
    const [listCamera, setListCamera] = useState<StationCameraItem[]>([]);
    const refreshKey = useIntervalRerender(30000);
    useEffect(() => {
        const fetchListCamera = async () => {
            try {
                const res = await stationCameraSvc.getAll({ stationId: stationId.toString() });
                if (res && res.content) {
                    const data = res.content.items;
                    setListCamera(data);
                }
            } catch (error) {
                console.error('Error fetching list of cameras:', error);
            }
        };
        fetchListCamera();
    }, [stationId]);

    const handleOpen = (camera: StationCameraItem) => {
        setSelectedCamera(camera);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedCamera(null);
    };

    return (
        <>
            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {listCamera.length > 0 ? listCamera.map((camera, index) => (
                    <div key={index} className="col-span-1">
                        <h3 className="font-semibold mb-2">{camera.title}</h3>
                        <div className="camera_thumbnail" onClick={() => handleOpen(camera)}>
                            {/* <ThumbnailGenerator streamUrl={camera.cameraUrl} /> */}
                            <img className="w-full h-full"
                                src={convertToThumbnailUrl(camera.cameraUrl) + `?t=${refreshKey}`}
                                alt={camera.title}
                                onError={(e) => {
                                    e.currentTarget.src = '/assets/images/no-image.png';
                                }}
                            />
                            <div className="camera_thumbnail_overlay">
                                <PlayIcon color="white" size={24} />
                            </div>
                        </div>
                    </div>
                )) : (
                    <p className="text-center">Không có camera</p>
                )}
            </div>
            {/* <WebRTCComponent streamUrl={'https://test.antmedia.io:5443/WebRTCAppEE/play.html?id=randomStreamName18784&playOrder=webrtc'} /> */}
            {/* <WebRTCAntMedia streamId="randomStreamName18784" serverUrl="wss://test.antmedia.io:5443/WebRTCAppEE/websocket" /> */}
            <DialogIframe
                isOpen={open}
                onClose={handleClose}
                camera={selectedCamera}
            />
        </>
    );
}

export default CameraComponent
